// Hook RQ para buscar terceros en el ERP externo por NIT (no cachea
// listado completo: los ERP suelen tener miles de proveedores y paginar).
//
// Uso:
//   const { data, isFetching, refetch } = useProveedorExternoPorNit(nitState);
//   data === { configurado, providerNombre, proveedores: [...] }
//
// El hook esta `enabled:false` cuando nit es vacio o muy corto, asi el
// usuario controla cuando dispara la consulta (boton lupa).

import { useQuery } from '@tanstack/react-query';
import { buscarProveedorExternoPorNit } from '../api/finanzas';

const STALE_5_MIN = 1000 * 60 * 5;
const NIT_MINIMO = 5; // evita consultas con valores muy cortos

export function useProveedorExternoPorNit(nit) {
  const valor = (nit || '').trim();
  return useQuery({
    queryKey: ['proveedorExternoPorNit', valor],
    queryFn: async () => {
      const resp = await buscarProveedorExternoPorNit(valor);
      return resp?.data?.data || { configurado: false, proveedores: [] };
    },
    enabled: valor.length >= NIT_MINIMO,
    staleTime: STALE_5_MIN,
    gcTime: STALE_5_MIN,
    retry: 0,
    refetchOnWindowFocus: false
  });
}
